import * as Artist from './Artist';
import { take } from "../../util";
export const fromGql = (item) => (Object.assign(Object.assign({}, take(item, 'id')), { artist: item.artist ? Artist.fromGql(item.artist) : undefined }));
export const fromGqlCollection = (items) => items.map(item => fromGql(item));
//# sourceMappingURL=EventArtist.js.map